import { render, staticRenderFns } from "./BenutzerRollen.vue?vue&type=template&id=7fd8d3b0&scoped=true"
import script from "./BenutzerRollen.vue?vue&type=script&lang=js"
export * from "./BenutzerRollen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd8d3b0",
  null
  
)

export default component.exports